/** Длинная сторона картинки слайда: экран телефона 1080×1920. */
export const SHRINK_MAX_SIDE = 1920

/**
 * Ужать картинку до размера экрана телефона и перекодировать в JPEG — только
 * для mock-хранилища, у которого всего несколько мегабайт. Браузер не умеет
 * (нет `createImageBitmap` или холста) или картинка и так мала — отдаём файл
 * как есть: лучше большой файл, чем никакого.
 */
export async function shrinkImage(file: File): Promise<File> {
  if (typeof createImageBitmap !== 'function') return file
  try {
    const bitmap = await createImageBitmap(file)
    const scale = Math.min(1, SHRINK_MAX_SIDE / Math.max(bitmap.width, bitmap.height))
    const canvas = document.createElement('canvas')
    canvas.width = Math.round(bitmap.width * scale)
    canvas.height = Math.round(bitmap.height * scale)
    const context = canvas.getContext('2d')
    if (!context) return file
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height)
    bitmap.close()
    const blob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob(resolve, 'image/jpeg', 0.82)
    })
    if (!blob || blob.size >= file.size) return file
    return new File([blob], file.name.replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' })
  } catch {
    return file
  }
}
